'use client';

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ImageLightboxProps {
	image?: string | null;
	onClose?: () => void;
	hasPreviousImage?: boolean;
	hasNextImage?: boolean;
	currentImgNumber?: number;
	totalCount?: number;
	onNextClick?: () => void;
	onPreviousClick?: () => void;
}

export const ImageLightbox = ({
	image,
	onClose,
	onNextClick,
	onPreviousClick,
	hasPreviousImage,
	hasNextImage,
	currentImgNumber,
	totalCount
}: ImageLightboxProps) => {
	if (!image) return null;

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75">
			<div className="relative flex w-full max-w-[95vw] flex-col items-center gap-4 rounded-lg bg-[#101828] p-10">
				<button onClick={onClose} className="absolute right-4 top-3 text-2xl text-white hover:text-gray-300">
					<FontAwesomeIcon icon={faTimes} />
				</button>

				{hasPreviousImage && (
					<button
						onClick={onPreviousClick}
						className="absolute left-2 top-[45%] size-6 rounded-full border border-white text-white hover:border-gray-300 hover:text-gray-300 sm:left-4 md:size-12"
					>
						<FontAwesomeIcon icon={faChevronLeft} />
					</button>
				)}

				{hasNextImage && (
					<button
						onClick={onNextClick}
						className="absolute right-2 top-[45%] size-6 rounded-full border border-white text-white hover:border-gray-300 hover:text-gray-300 sm:right-4 md:size-12"
					>
						<FontAwesomeIcon icon={faChevronRight} />
					</button>
				)}

				{currentImgNumber && totalCount && (
					<div className="text-white">
						{currentImgNumber}/{totalCount}
					</div>
				)}

				<img src={image} alt="Lightbox" />
			</div>
		</div>
	);
};
